var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", [
    _c(
      "main",
      [
        _c(_setup.ContactsBanner, { staticClass: "mb-5" }),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "pt-5 pb-1 px-2" },
          _vm._l(_setup.context.company_contacts, function (contact, i) {
            return _c(_setup.ContactsItemBlock, {
              key: i,
              staticClass: "mb-8",
              attrs: { contact: contact },
            })
          }),
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "border-t-sm my-5 mx-2" }),
        _vm._v(" "),
        _c(
          "section",
          { staticClass: "py-5 px-2" },
          [
            _vm._l(
              _setup.context.company_ceo_contacts,
              function (ceo_contact, i) {
                return _c(
                  "div",
                  { key: i },
                  [
                    _c(_setup.ContactsSeoProfile, {
                      attrs: { profile: ceo_contact },
                    }),
                    _vm._v(" "),
                    _c(_setup.ContactsAddresses, {
                      attrs: { addresses: ceo_contact.addresses.all },
                    }),
                  ],
                  1
                )
              }
            ),
            _vm._v(" "),
            _c(_setup.ContactsMap, {
              attrs: { "map-data": _setup.context.company_ceo_contacts[0] },
            }),
          ],
          2
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }